/**
 * Signaling client role.
 */
export enum Role {
    MASTER = 'MASTER',
    VIEWER = 'VIEWER',
}
